import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { breakpoints } from 'shared/lib';
import { ConfirmModalProps, createConfirmModal } from 'shared/ui';
import ActivateIcon from 'shared/ui/assets/activate-icon.svg?react';
import { CancelPromocodeModel } from '../../model';
import cls from './cancel-promocode-modal.module.scss';

export const createCancelPromocodeModal = (model: CancelPromocodeModel) => {
	const ConfirmModal = createConfirmModal(model);

	const CancelPromocodeModal = forwardRef<HTMLDivElement, ConfirmModalProps>(
		({ ...props }, ref) => {
			const { t } = useTranslation();

			const md = useUnit(breakpoints.md);

			return (
				<ConfirmModal
					ref={ref}
					title={
						<span className={cls.cancelPromocodeModalTitle}>{t('cancel-promocode.title')}</span>
					}
					submitButtonProps={{
						children: t('cancel-promocode.cancel'),
						leftSection: <ActivateIcon />,
						variant: 'destructive',
						size: md ? 'xl' : 'lg',
						fullWidth: true,
						'data-test-id': 'cancel-promocode-submit',
					}}
					variant='default'
					size={md ? '2xl' : 'xl'}
					{...props}
				>
					<span className={cls.cancelPromocodeModalDescription}>
						{t('cancel-promocode.description')}
					</span>
				</ConfirmModal>
			);
		},
	);

	return CancelPromocodeModal;
};
